module.exports = __webpack_public_path__ + "img/fb-white-icon.8be71a92.svg";